<template>
  <div id="app">
    <TestModeBanner />
    <header class="header">
      <nav class="nav">
        <router-link to="/" class="nav-brand">
          <h1>🌟 Omni Hub</h1>
        </router-link>
        <div class="nav-links">
          <router-link to="/" class="nav-link">Dashboard</router-link>
          <router-link to="/code/changelog" class="nav-link">Changelog</router-link>
        </div>
      </nav>
      <p>Operations Dashboard for omni-craft</p>
    </header>
    
    <main class="main">
      <router-view />
    </main>
    
    <footer class="footer">
      <p>Powered by Vue 3 + Vite | Deployed on Cloudflare Pages</p>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { TestModeBanner } from '@orb-zone/nova-hub'
</script>

<style scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem;
  text-align: center;
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.nav-brand {
  text-decoration: none;
  color: inherit;
}

.nav-brand h1 {
  margin: 0;
  font-size: 2.5rem;
}

.nav-links {
  display: flex;
  gap: 1.5rem;
}

.nav-link {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: background-color 0.2s;
  opacity: 0.8;
}

.nav-link:hover,
.nav-link.router-link-active {
  background-color: rgba(255, 255, 255, 0.2);
  opacity: 1;
}

.header p {
  margin: 0;
  opacity: 0.9;
}

.main {
  flex: 1;
  padding: 2rem;
}

.footer {
  background: #f8f9fa;
  padding: 1rem;
  text-align: center;
  color: #6c757d;
  font-size: 0.9rem;
}
</style>